import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { LogOut, MailQuestion } from 'lucide-react';
import posLogo from '@/assets/posvision-logo.png';

/**
 * Fallback affiché pour les comptes auth sans tenant assigné.
 *
 * Remplace l'ancien `<SetupBusiness />` self-service (retiré le 2026-05-12)
 * car le flow d'onboarding self-service est en cours de refonte. En attendant,
 * les nouveaux marchands doivent être provisionnés manuellement par un
 * super_admin via le Portail Admin.
 *
 * Cf docs/_actions-manuelles.md pour le process actuel d'onboarding.
 */
export default function NoTenantAssigned() {
  const { signOut } = useAuth();

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-gradient-to-br from-[hsl(224,50%,14%)] to-[hsl(224,55%,8%)] px-4">
      <Card className="w-full max-w-md border-0 bg-[hsl(224,50%,12%)] text-white shadow-2xl">
        <CardContent className="space-y-6 p-8 text-center">
          <img src={posLogo} alt="VisionPos 360" className="mx-auto h-12 object-contain" />

          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/10">
            <MailQuestion className="h-8 w-8 text-amber-400" />
          </div>

          <div className="space-y-3">
            <h2 className="text-xl font-semibold">Compte en attente de provisionnement</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Ton compte est créé mais n'est pas encore associé à un établissement.
              <br />
              Contacte le support pour finaliser l'activation de ton commerce.
            </p>
          </div>

          <div className="space-y-2 rounded-lg bg-white/5 p-4 text-left text-sm">
            <p className="font-medium">📧 Contact</p>
            <a
              href="mailto:hello@linkvision.fr?subject=Activation%20compte%20VisionPos"
              className="block text-amber-400 hover:underline"
            >
              hello@linkvision.fr
            </a>
            <p className="pt-2 text-xs text-muted-foreground">
              Préciser ta raison sociale, SIRET et coordonnées dans ton message.
            </p>
          </div>

          <Button onClick={signOut} variant="outline" className="w-full gap-2">
            <LogOut className="h-4 w-4" />
            Se déconnecter
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
